
interface menu{
    isTitle:boolean
    hasChildren:boolean
    title?:string
    name?:string
    key?:string
    status?:boolean
    route?:string
    children?: menu[]
    elements?: menu[]
}
export const MenuAdminSys:menu[]=[
    {
        isTitle:true,
        title:"Accueil",
        hasChildren:false,
        status:true,
        elements:[
            {
                isTitle:false,
                key:"admin-dashboard",
                name:"Tableau de bord",
                route:'/admin/dashboard',
                hasChildren:false,
                status:true
            
            },
        ]
    },
    {
        isTitle:true,
        title:"Paramètres",
        hasChildren:false,
        status:true,
        elements:[
    {
        isTitle:false,
        name:"Gestion des utilisateurs",
        hasChildren:true,
        status:true,
        children:[
            {
                isTitle:false,
                name:"Utilisateurs",
                route:'/admin/users',
                hasChildren:false,
                status:true
            
            },
            {
                isTitle:false,
                name:"Rôles",
                route:'/admin/roles',
                hasChildren:false,
                status:true
            
            },
            {
                isTitle:false,
                name:"Fonctionnalité",
                route:'/admin/features',
                hasChildren:false,
                status:true,
            
            },
            {
                isTitle:false,
                name:"Permissions",
                route:'/admin/permissions',
                hasChildren:false,
                status:true
            
            },
            {
                isTitle:false,
                name:"Rôles et Permissions",
                route:'/admin/profiles',
                hasChildren:false,
                status:true
            
            },
        ]
    },
    ]
}
]
export const MenuTEST:menu[]=[
    {
        isTitle:true,
        title:"Accueil",
        hasChildren:false,
        status:false,
        elements:[
            {
                isTitle:false,
                key:"admin-dashboard",
                name:"Tableau de bord",
                route:'/admin/dashboard',
                hasChildren:false,
                status:false
            
            },
        ]
    },
    {
        isTitle:true,
        title:"Configurations",
        hasChildren:false,
        status:false,
        elements:[
            {
                isTitle:false,
                name:"Finances",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        key:"admin-payment-methods",
                        name:"Méthode de paiement",
                        route:'/admin/configurations/payment-methods',
                        hasChildren:false,
                        status:false
                    },
                    {
                        isTitle:false,
                        key:"admin-transactions",
                        name:"Transactions",
                        route:'/admin/transactions',
                        hasChildren:false,
                        status:false
                    }
                    
                ]
            },
            {
                isTitle:false,
                name:"Vie scolaire",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        key:"admin-academic-years",
                        name:"Année académique",
                        route:'/admin/configurations/academic-year',
                        hasChildren:false,
                        status:false
                    },
                    {
                        isTitle:false,
                        key:"admin-cycles",
                        name:"Cycle",
                        route:'/admin/configurations/cycles',
                        hasChildren:false,
                        status:false
                    },
                    {
                        isTitle:false,
                        name:"Matières",
                        key:"admin-courses",
                        route:'/admin/configurations/courses',
                        status:false,
                        hasChildren:false
                    },
                    {
                        isTitle:false,
                        name:"Catégorie d'information",
                        key:"admin-category-informations",
                        route:'/admin/configurations/category-informations',
                        status:false,
                        hasChildren:false
                    },
                    {
                        isTitle:false,
                        name:"Informations utiles",
                        key:"admin-useful-informations",
                        route:'/admin/configurations/useful-informations',
                        status:false,
                        hasChildren:false
                    },
                    {
                        isTitle:false,
                        name:"Agenda",
                        key:"admin-agendas",
                        route:'/admin/configurations/agendas',
                        status:false,
                        hasChildren:false
                    },
                    {
                        isTitle:false,
                        name:"Sondage",
                        key:"admin-polls",
                        route:'/admin/configurations/polls',
                        status:false,
                        hasChildren:false
                    },
                    {
                        isTitle:false,
                        name:"Modèle de livrable",
                        key:"admin-templates",
                        route:'/admin/configurations/templates',
                        hasChildren:false,
                        status:false,
                    }
                ]
            },
            {
                isTitle:false,
                name:"Administration",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        name:"Ecole",
                        key:"admin-school",
                        route:'/admin/configurations/school',
                        hasChildren:false,
                        status:false
                    },
                    {
                        isTitle:false,
                        name:"Paramètres généraux",
                        key:"admin-settings",
                        route:'/admin/configurations/settings',
                        status:false,
                        hasChildren:false
                    },
                    {
                        isTitle:false,
                        name:"Salle",
                        key:"admin-rooms",
                        route:'/admin/configurations/rooms',
                        hasChildren:false,
                        status:false
                    },
                    {
                        isTitle:false,
                        name:"Periodes",
                        key:"admin-periods",
                        route:'/admin/configurations/periods',
                        hasChildren:false,
                        status:false
                    },
                    {
                        isTitle:false,
                        name:"Arrêt de note",
                        key:"admin-stop-notes",
                        route:'/admin/configurations/stop-notes',
                        hasChildren:false,
                        status:false
                    },
                    {
                        isTitle:false,
                        name:"Migration de classe",
                        key:"admin-classroom-passations",
                        route:'/admin/configurations/classroom-passations',
                        hasChildren:false,
                        status:false
                    },
                    {
                        isTitle:false,
                        name:"Personnel",
                        key:"admin-personals",
                        route:'/admin/configurations/personals',
                        hasChildren:false,
                        status:false
                    }
                ]
            },
        ]
    },
    {
        isTitle:true,
        title:"Paramètres & Comptes",
        hasChildren:false,
        status:false,
        elements:[ 
            {
                isTitle:false,
                name:"Gestion des utilisateurs",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        name:"Utilisateurs",
                        key:"admin-users",
                        route:'/admin/users',
                        hasChildren:false,
                        status:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Rôles",
                        key:"admin-roles",
                        route:'/admin/roles',
                        hasChildren:false,
                        status:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Fonctionnalité",
                        key:"admin-features",
                        route:'/admin/features',
                        hasChildren:false,
                        status:false,
                    
                    },
                    {
                        isTitle:false,
                        name:"Permissions",
                        key:"admin-permissions",
                        route:'/admin/permissions',
                        hasChildren:false,
                        status:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Rôles et Permissions",
                        key:"admin-profiles",
                        route:'/admin/profiles',
                        hasChildren:false,
                        status:false
                    
                    },
                ]
            },
            {
                isTitle:false,
                name:"Sauvegarde",
                key:"admin-backups",
                route:'/admin/configurations/backups',
                hasChildren:false,
                status:false
            
            },
        ]
    },
    {
        isTitle:true,
        title:"Communications",
        hasChildren:false,
        status:false,
        elements:[  
            {
                isTitle:false,
                name:"Préoccupations",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        name:"Nouvelle préoccupation",
                        key:"admin-inqueries",
                        route:'/admin/inqueries/index/new',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"A résoudre",
                        key:"admin-inqueries",
                        route:'/admin/inqueries/index/pending',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Mes requêtes",
                        key:"admin-inqueries",
                        route:'/admin/inqueries/index/own',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Parcours",
                        key:"admin-inqueries",
                        route:'/admin/inqueries-parcours',
                        status:false,
                        hasChildren:false
                    
                    },
                ]
            },
        ]
    },
    {
        isTitle:true,
        title:"Vie Scolaire",
        hasChildren:false,
        status:false,
        elements:[
          
            {
                isTitle:false,
                name:"Configurations",
                hasChildren:true,
                status:false,
                children:[
               
                    {
                        isTitle:false,
                        name:"Série",
                        key:"admin-levels",
                        route:'/admin/configurations/levels',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Classe",
                        key:"admin-classrooms",
                        route:'/admin/configurations/classrooms',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Documents",
                        key:"admin-documents",
                        route:'/admin/configurations/documents',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Document pour inscription",
                        key:"admin-inscription-files",
                        route:'/admin/configurations/inscription-files',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Validation des inscriptions par classe",
                        key:"admin-inscription-validations",
                        route:'/admin/configurations/inscription-validations',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Liste des professeurs",
                        key:"admin-professors-list",
                        route:'/admin/professors/list',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Enseignant et classe",
                        key:"admin-professors-classrooms",
                        route:'/admin/professors/classrooms',
                        status:false,
                        hasChildren:false
                    
                    },
        
                    {
                        isTitle:false,
                        name:"Enseignant et Matière",
                        key:"admin-professors-courses",
                        route:'/admin/professors/courses',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Emploi du temps",
                        key:"admin-timetable",
                        route:'/admin/timetable',
                        status:false,
                        hasChildren:false
                    
                    },
                ]
            
            },
            {
                isTitle:false,
                name:"Inscription",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        name:"Nouvelle",
                        route:'/admin/inscription-create',
                        hasChildren:false,
                        key:"admin-inscription-new",
                        status:false
                    },
                    {
                        isTitle:false,
                        name:"Réinscription",
                        key:"admin-inscription-renew",
                        route:'/admin/inscription-renew',
                        hasChildren:false,
                        status:false
                    },
                    {
                        isTitle:false,
                        name:"Liste des inscrits",
                        key:"admin-inscription",
                        route:'/admin/inscription',
                        hasChildren:false,
                        status:false
                    }
                ]
            
            },
            {
                isTitle:false,
                name:"Liste des élèves",
                key:"admin-students",
                route:'/admin/students',
                hasChildren:false,
                status:false
            },
            {
                isTitle:false,
                name:"Notes et compositions",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        name:"Fiche de note",
                        key:"admin-note-index",
                        route:'/admin/note-index',
                        status:false,
                        hasChildren:false
                    },
              
                    {
                        isTitle:false,
                        name:"Composition par matière",
                        key:"admin-composition-index",
                        route:'/admin/composition-index',
                        status:false,
                        hasChildren:false
                    },
              
                    {
                        isTitle:false,
                        name:"Composition par Classe",
                        key:"admin-composition-by-classrooms",
                        route:'/admin/composition-by-classrooms',
                        status:false,
                        hasChildren:false
                    },
                    {
                        isTitle:false,
                        name:"Cahier de note par élève",
                        key:"admin-note-book",
                        route:'/admin/note-book',
                        status:false,
                        hasChildren:false
                    },
                    {
                        isTitle:false,
                        name:"Cahier de note par matière",
                        key:"admin-note-book-professor",
                        route:'/admin/note-book-professor',
                        status:false,
                        hasChildren:false
                    },
                    {
                        isTitle:false,
                        name:"Validation des bulletins",
                        key:"admin-bulletin-validations",
                        route:'/admin/bulletin-validations',
                        status:false,
                        hasChildren:false
                    
                    },
                    
                    {
                        isTitle:false,
                        name:"Bulletin",
                        key:"admin-bulletins",
                        route:'/admin/bulletins',
                        status:false,
                        hasChildren:false
                    },
              
                    {
                        isTitle:false,
                        name:"Bulletins générés",
                        key:"admin-bulletins-generated",
                        route:'/admin/bulletins-generated',
                        status:false,
                        hasChildren:false
                    }
              
                ]
            
            },
            {
                isTitle:false,
                name:"Cahier de texte",
                key:"admin-textbooks",
                route:'/admin/textbooks',
                status:false,
                hasChildren:false
            
            },
            {
                isTitle:false,
                name:"Suivi des acquis",
                key:"admin-followed-archievements",
                route:'/admin/followed-archievements',
                status:false,
                hasChildren:false
            
            },
            {
                isTitle:false,
                name:"Gestion des présences",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        name:"Nouvel enregistrement",
                        key:"admin-bvs-attendances-create",
                        route:'/admin/bvs-attendances-create',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Cahier de présence",
                        key:"admin-bvs-attendances-book",
                        route:'/admin/bvs-attendances-book',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Sanction",
                        key:"admin-bvs-sanctions",
                        route:'/admin/bvs-sanctions/index',
                        status:false,
                        hasChildren:false
                    
                    },
                  
                    {
                        isTitle:false,
                        name:"Demande permission",
                        key:"admin-bvs-request-permissions",
                        route:'/admin/bvs-request-permissions/index',
                        status:false,
                        hasChildren:false
                    
                    },
                ]
            },
            {
                isTitle:false,
                name:"Suivi de l'apprenant",
                hasChildren:true,
                status:false,
                children:[ 
                    {
                        isTitle:false,
                        name:"Point de présence",
                        key:"admin-student-attendances",
                        route:'/admin/student-attendances',
                        status:false,
                        hasChildren:false
                    
                    },
                    {
                        isTitle:false,
                        name:"Dispense de l'élève",
                        key:"admin-student-dispensations",
                        route:'/admin/student-dispensations',
                        status:false,
                        hasChildren:false
                    
                    },
                ]
            },
            {
                isTitle:false,
                name:"Infirmerie",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        name:"Donnée de santé",
                        key:"admin-infimary-healths",
                        route:'/admin/infimary-healths',
                        hasChildren:false,
                        status:false,
                    
                    },
                    {
                        isTitle:false,
                        name:"Donnée de contrôle",
                        key:"admin-infimary-health-controls",
                        route:'/admin/infimary-health-controls',
                        hasChildren:false,
                        status:false,
                    
                    },
                    {
                        isTitle:false,
                        name:"Donnée de vaccinations",
                        key:"admin-infimary-vacctinations",
                        route:'/admin/infimary-vacctinations',
                        hasChildren:false,
                        status:false,
                
                    
                    }
                 ]
            },
        ]
    },
]
